import { useNavigate } from 'react-router-dom'
import { UserCog, Flag, Shield, Smartphone, User, Tags, ClipboardList, Bell, FileText } from 'lucide-react'

const sections = [
  { title: 'Político', description: 'Dados do político, cargo, partido e redes sociais', icon: User, path: '/settings/political' },
  { title: 'Formulário de Eleitor', description: 'Escolha os campos do cadastro (aparece / obrigatório), interno e público', icon: FileText, path: '/settings/voter-form' },
  { title: 'Categorias', description: 'Categorize contatos e eleitores por grupos', icon: Tags, path: '/settings/categories' },
  { title: 'Campanhas', description: 'Gerencie campanhas eleitorais e histórico', icon: Flag, path: '/settings/campaigns' },
  { title: 'Demandas', description: 'Configure funis, etapas e categorias de demandas', icon: ClipboardList, path: '/settings/demands' },
  { title: 'Usuários', description: 'Gerencie usuários e permissões do sistema', icon: UserCog, path: '/settings/users' },
  { title: 'Segurança', description: 'Senhas, autenticação e acessos', icon: Shield, path: '/settings/security' },
  { title: 'App', description: 'Configure o app mobile da campanha', icon: Smartphone, path: '/settings/app' },
  { title: 'Notificações Push', description: 'Envie avisos pra apoiadores que têm o app', icon: Bell, path: '/settings/notifications' },
]

export default function ConfiguracoesPage() {
  const navigate = useNavigate()

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Configurações</h1>
        <p className="text-gray-500 mt-1">Gerencie as configurações do sistema</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {sections.map(section => {
          const Icon = section.icon
          return (
            <div
              key={section.title}
              onClick={() => navigate(section.path)}
              className="bg-white rounded-2xl border border-gray-200 p-6 hover:shadow-sm transition-shadow cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-brand-50 text-brand-500 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Icon className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-800">{section.title}</h3>
                  <p className="text-sm text-gray-500 mt-1">{section.description}</p>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
